"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _classnames = _interopRequireDefault(require("classnames"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ComponentWrapper = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    /* this padding property is ignored if theres aspect ratio set */\n    padding: ", ";\n\n    max-width: ", ";\n\n    padding-bottom: ", ";\n\n    @media all and (min-width: ", ") {\n        padding-bottom: ", ";\n\n        max-width: ", ";\n    }\n\n    @media all and (min-width: ", ") {\n        max-width: ", ";\n    }\n\n    @media all and (min-width: ", ") {\n        max-width: ", ";\n    }\n\n    @media all and (min-width: ", ") {\n        max-width: ", ";\n    }\n\n    margin-left: ", ";\n    margin-right: ", ";\n\n    > div {\n        ", ";\n\n        display: ", ";\n        justify-content: center;\n        align-items: ", ";\n\n        &.mobile-two-col-layout {\n            // Ory's grid's 'sm' breakpoint starts at 768px.\n            // We have to use max-width here because otherwise it'll override the grid layout on\n            // 'sm' and up due to the increased specificity.\n            @media all and (max-width: 767px) {\n                .ory-cell-xs-12 {\n                    width: 50%;\n                    min-width: 50%;\n                    flex-basis: 50%;\n\n                    .ory-cell-xs-12 {\n                        width: 100%;\n                        min-width: 100%;\n                        flex-basis: 100%;\n                    }\n                }\n            }\n        }\n\n        &.container__match-height {\n            > .ory-row,\n            > .ory-dimensions > .ory-row-droppable-container > .ory-row {\n                align-items: stretch !important;\n\n                &.ory-cell-inner > .ory-cell * {\n                    display: flex;\n                    height: 100%;\n                    flex-direction: column;\n                    max-width: 100%;\n                }\n\n                .content__text {\n                    margin: 0 !important;\n                }\n            }\n\n            .ory-cell-inner {\n                width: 100%;\n            }\n        }\n\n        &.container__align-content--top {\n            > .ory-row,\n            > .ory-dimensions > .ory-row-droppable-container > .ory-row {\n                align-items: flex-start;\n            }\n        }\n\n        &.container__align-content--center {\n            > .ory-row,\n            > .ory-dimensions > .ory-row-droppable-container > .ory-row {\n                align-items: center;\n            }\n        }\n\n        &.container__align-content--end {\n            > .ory-row,\n            > .ory-dimensions > .ory-row-droppable-container > .ory-row {\n                align-items: flex-end;\n            }\n        }\n    }\n"])), function (props) {
  return props.aspectRatio ? null : props.isPreviewMode ? '0px' : '0.625em';
}, function (props) {
  return props.theme.sizes.full;
}, function (props) {
  return props.aspectRatio ? function () {
    switch (props.aspectRatio) {
      case '4:3':
        return "75%";

      default:
        return "100%";
    }
  } : props.isPreviewMode ? '0px' : '0.625em';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.sm;
}, function (props) {
  return props.aspectRatio ? function () {
    switch (props.aspectRatio) {
      case '4:3':
        return "75%";

      case '16:9':
        return "56.25%";

      case '2:1':
        return "50%";

      default:
        return "100%";
    }
  } : props.isPreviewMode ? '0px' : '0.625em';
}, function (props) {
  switch (props.container) {
    case 'wide':
    case 'standard':
      return "".concat(props.containerType == 'fluid' ? props.theme.sizes.full : props.theme.sizes.containers.sm);
  }
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.md;
}, function (props) {
  switch (props.container) {
    case 'wide':
    case 'standard':
      return "".concat(props.containerType == 'fluid' ? props.theme.sizes.full : props.theme.sizes.containers.md);

    case 'narrow':
      return props.theme.sizes.containers.md;
  }
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.lg;
}, function (props) {
  switch (props.container) {
    case 'wide':
      return "".concat(props.containerType == 'fluid' ? props.theme.sizes.full : props.theme.sizes.containers.lg);

    case 'standard':
      return "".concat(props.theme.sizes.containers.lg);
  }
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.xl;
}, function (props) {
  switch (props.container) {
    case 'wide':
      return "".concat(props.theme.sizes.containers.xl);
  }
}, function (props) {
  return props.container !== 'full' ? 'auto' : '0';
}, function (props) {
  return props.container !== 'full' ? 'auto' : '0';
}, function (props) {
  return props.aspectRatio ? "position: absolute;\n                    top: 0;\n                    left; 0;\n                    width: 100%;\n                    height: 100%;" : null;
}, function (props) {
  return props.aspectRatio ? 'flex' : 'static';
}, function (props) {
  return props.alignContent;
});

var Component = function Component(_ref5) {
  var _window, _window$location;

  var _ref5$state = _ref5.state,
      _ref5$state$container = _ref5$state.containerSize,
      containerSize = _ref5$state$container === void 0 ? 'full' : _ref5$state$container,
      _ref5$state$container2 = _ref5$state.containerType,
      containerType = _ref5$state$container2 === void 0 ? 'fluid' : _ref5$state$container2,
      _ref5$state$aspectRat = _ref5$state.aspectRatio,
      aspectRatio = _ref5$state$aspectRat === void 0 ? '' : _ref5$state$aspectRat,
      _ref5$state$alignCont = _ref5$state.alignContent,
      alignContent = _ref5$state$alignCont === void 0 ? 'flex-start' : _ref5$state$alignCont,
      matchContentHeight = _ref5$state.matchContentHeight,
      mobileTwoColumnLayout = _ref5$state.mobileTwoColumnLayout,
      children = _ref5.children,
      isPreviewMode = _ref5.isPreviewMode;
  var inStorefront = !((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname.includes('/content/edit/'));
  return /*#__PURE__*/_react["default"].createElement(ComponentWrapper, {
    container: containerSize,
    containerType: containerType,
    isPreviewMode: inStorefront,
    aspectRatio: aspectRatio,
    alignContent: alignContent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])({
      'container__match-height': matchContentHeight,
      'container__align-content--top': alignContent === 'flex-start',
      'container__align-content--center': alignContent === 'center',
      'container__align-content--end': alignContent === 'flex-end',
      'mobile-two-col-layout': mobileTwoColumnLayout
    })
  }, children));
};

var _default = Component;
exports["default"] = _default;